import { RouteObject } from "react-router-dom";

export const warrantyPolicyRoutes: RouteObject[] = [
  {
    children: [
      {
        path: "",
        lazy: async () => {
          const { WarrantyPolicyPage } =
            // redont-allow-dynamic-import: route-level code splitting
            await import("@redotech/redo-customer-portal-warranties-app/warranties/policies/warranty-policy-page");
          return { element: <WarrantyPolicyPage /> };
        },
      },
    ],
  },
];
